import { ViewStyle } from 'react-native'
import { createUseStyles } from '../../styles/create-use-styles'

interface ToastStyles {
  toastContainer: ViewStyle
  toastContainerWeb: ViewStyle
  toastSubContainer: ViewStyle
  toastMessageText: ViewStyle
  closeButton: ViewStyle
  progressBar: ViewStyle
}

interface ToastPropsStyles {
  hasErrored: boolean
  isDesktop: boolean
  toastWidth: number
}

const PROGRESS_BAR_HEIGHT = 2

// ts-ignore since "position: fixed" is not allowed in RN &
// it is needed for displaying toast at the bottom right of the screen above "lg" breakpoint
// @ts-ignore
export const useStyles = createUseStyles<ToastStyles, ToastPropsStyles>((theme, props) => {
  const { hasErrored, isDesktop, toastWidth } = props

  const baseToastContainer = {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: hasErrored ? theme.colors.webErrorColor : theme.colors.webSuccessBackground,
    borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
    width: theme.calcUnit(toastWidth),
  }

  return {
    toastContainer: {
      ...baseToastContainer,
      alignSelf: 'center',
    },
    toastContainerWeb: {
      ...baseToastContainer,
      position: 'fixed',
      bottom: theme.calcUnit(theme.spacing.s16),
      alignSelf: isDesktop ? 'flex-end' : 'center',
      right: isDesktop ? theme.calcUnit(theme.spacing.s10) : 'auto',
    },
    toastSubContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      paddingInline: theme.calcUnit(theme.spacing.s2),
      paddingTop: theme.calcUnit(theme.spacing.s3),
      paddingBottom: theme.calcUnit(theme.spacing.s3),
    },
    toastMessageText: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: theme.calcUnit(theme.spacing.s1),
    },
    closeButton: {
      backgroundColor: hasErrored ? theme.colors.webErrorColor : theme.colors.webSuccessBackground,
    },
    progressBar: {
      position: 'absolute',
      bottom: theme.calcUnit(0),
      left: theme.calcUnit(0),
      height: theme.calcUnit(PROGRESS_BAR_HEIGHT),
      backgroundColor: theme.colors.lightTextColor,
    },
  }
})
